module.exports = __webpack_public_path__ + "chat_1_1.da41fc4103d563adac978dfe3841b84d.svg";